import { MarketName } from "@/constants/marketName"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    supplyPoint: graphql(`
        fragment isGasSupplyPoint_SupplyPoint on SupplyPointType {
            marketName
        }
    `),
}

export function isGasSupplyPoint(fragment: FragmentOf<typeof graphQLFragments.supplyPoint>) {
    const supplyPoint = readFragment(graphQLFragments.supplyPoint, fragment)

    return supplyPoint?.marketName === MarketName.FRA_GAS
}

isGasSupplyPoint.fragments = graphQLFragments
